import { datadogLogs } from '@datadog/browser-logs';

function constructErrorMessage(error) {
  const errorInstance =
    error instanceof Error ? error : new Error(String(error));
  return {
    errorMessage: errorInstance.message,
  };
}

export function logWebHrWarning({ message, metadata = {}, source }) {
  const logger = datadogLogs.logger;
  const messageContext = {
    env: process.env.API_ENV,
    metadata: { ...metadata, source },
  };

  console.warn(message, messageContext);
  logger.warn(message, messageContext);
}

export function logWebHrError({ message, metadata = {}, source, error }) {
  const logger = datadogLogs.logger;

  const { errorMessage } = constructErrorMessage(error);
  const messageContext = {
    env: process.env.API_ENV,
    metadata: { ...metadata, source, errorMessage },
  };

  console.error(error, messageContext);
  logger.error(message, messageContext, error);
}

export function logWebHrCritical({ message, metadata = {}, source, error }) {
  const logger = datadogLogs.logger;

  const { errorMessage } = constructErrorMessage(error);
  const messageContext = {
    env: process.env.API_ENV,
    metadata: { ...metadata, source, errorMessage },
  };

  console.error(error, messageContext);

  logger.critical(message, messageContext, error);
}
